import ResizableWrapper from '@/components/common/ResizableWrapper';
import { SessionData } from '@/types/analytics';
import { CircularProgress, Stack, useTheme } from '@mui/material';
import { FC } from 'react';
import { useLocalStorage, useSessionStorage } from 'usehooks-ts';
import BlockDetails from './BlockDetails';
import SessionFlow from './SessionFlow';

type SessionLogsProps = {
  name: string;
  uuid: string;
  sessionData: SessionData | undefined;
  navigateToBuilder: (blockId: string) => void;
  isLoading: boolean;
};

const SessionLogs: FC<SessionLogsProps> = ({ name, uuid, sessionData, navigateToBuilder, isLoading }) => {
  const theme = useTheme();
  const baseWidth = parseInt(theme.spacing(50), 10);
  const maxWidth = document.body.clientWidth / 2 - parseInt(theme.spacing(2), 10);

  const [initialWidth, setInitialWidth] = useLocalStorage('NodeSettingsListWidth', baseWidth);
  const [selectedRow, setSelectedRow] = useSessionStorage<number>('SessionSelectedRow', 0);

  return (
    <Stack>
      {isLoading ? (
        <Stack alignItems='center' mt={10}>
          <CircularProgress color='inherit' />
        </Stack>
      ) : !sessionData?.lines.length ? (
        <Stack alignItems='center' mt={10}>
          No Session Data found
        </Stack>
      ) : (
        <Stack direction='row' width={'100%'}>
          {sessionData && (
            <SessionFlow
              name={name}
              uuid={uuid}
              sessionData={sessionData}
              selectedRow={selectedRow}
              setSelectedRow={(row) => setSelectedRow(row)}
              navigateToBuilder={navigateToBuilder}
            />
          )}
          <ResizableWrapper
            minWidth={baseWidth}
            maxWidth={maxWidth}
            initialWidth={initialWidth}
            handlePosition='left'
            handleWidth={5}
            onResize={(newWidth) => setInitialWidth(newWidth)}
          >
            <BlockDetails sessionData={sessionData} selectedRow={selectedRow} />
          </ResizableWrapper>
        </Stack>
      )}
    </Stack>
  );
};

export default SessionLogs;
